import config from 'utils/config';
import { useFetchUserMindsetSettings } from 'actions/userProfile';

// Domain-level checks — not user-specific

export var isMindsetEnabledInHub = !!config.mindsetAppUid;
export var isMindsetBankConfigured = !!config.mindsetBankUid;
export function useShowMindsetInPage() {
  var _useFetchUserMindsetS = useFetchUserMindsetSettings(),
    hasMindsetAgent = _useFetchUserMindsetS.hasMindsetAgent;
  return config.isTrialHub && hasMindsetAgent;
}